import { GrantRepository } from '../../../services/grants';
import ShellLocalStorageDAOImpl from '../../../dao/ShellLocalStorageDAOImpl';
import { EntitlementRepository } from '../../../services/entitlements/EntitlementRepository';
import { ScopeRepository } from '../../../services/scope';
import { ActionRepository } from '../../../services/action/ActionRepository';
import { TenantRepository } from '../../../services/tenantHandler';
import { RepositoriesType } from './RepositoriesType';
import { container } from 'tsyringe';
import AuthTokenRepository from '../../../services/authTokenService/AuthTokenRepository';
import IdTokenRepository from '../../../services/session/IdTokenRepository';
import { PendingGrantRepository } from '../../../services/grants/PendingGrantRepository';
import { GrantHistoryRepository } from '../../../services/grants/grantsHistory';
import { LastTenantIdsRepository } from '../../../behaviors/beforeInitBehaviors/MultipleTabsDeamon/LastTenantIdsRepository';
import { HandledTenantsRepository } from '../../../services/tenantHandler/HandledTenantsRepository';

export default class RepositoryInitializer {
  public static instantiate(): RepositoriesType {
    const shellLocalStorageDAO = container.resolve(ShellLocalStorageDAOImpl);

    const scopeRepository = new ScopeRepository({
      shellDAO: shellLocalStorageDAO
    });

    const actionRepository = new ActionRepository({
      shellDAO: shellLocalStorageDAO
    });

    const authTokenRepository = container.resolve(AuthTokenRepository);

    const tenantRepository = new TenantRepository({
      shellDAO: shellLocalStorageDAO
    });
    const entitlementRepository = new EntitlementRepository({
      shellDAO: shellLocalStorageDAO
    });

    const idTokenRepository = container.resolve(IdTokenRepository);

    const grantRepository = new GrantRepository({
      shellDAO: shellLocalStorageDAO
    });
    const grantHistoryRepository = new GrantHistoryRepository({
      shellDAO: shellLocalStorageDAO
    });

    const pendingGrantRepository = new PendingGrantRepository({
      shellDAO: shellLocalStorageDAO
    });

    //  For security reasons, we added the _lastTenantIdsRepository, in order to clean up the last tenant ids user was logged in.
    const lastTenantIdsRepository = new LastTenantIdsRepository({
      shellDAO: shellLocalStorageDAO
    });

    const handledTenantsRepository = new HandledTenantsRepository(
      shellLocalStorageDAO
    );

    const repositories = {
      scopeRepository,
      actionRepository,
      authTokenRepository,
      tenantRepository,
      entitlementRepository,
      idTokenRepository,
      grantRepository,
      lastTenantIdsRepository,
      grantHistoryRepository,
      pendingGrantRepository,
      handledTenantsRepository
    };

    return repositories;
  }
}
